import { Button, EmptyState } from '@aurora/ui-kit';
import { Link } from 'react-router';

export function NotFoundPage() {
  return (
    <div className="page">
      <EmptyState
        title="Seite nicht gefunden"
        description="Die angeforderte Seite existiert nicht oder das Modul ist nicht aktiviert."
        action={
          <Link to="/">
            <Button variant="ghost">Zum Dashboard</Button>
          </Link>
        }
      />
    </div>
  );
}
